import React from 'react';
import { FaPhone, FaFilter } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import HeroSearchBar from './HeroSearchBar';
import './header.css';


const Header = () => {
    const { t } = useApp();
    const navigate = useNavigate();

    return (
        <header className="header">
            {/* Hero Section */}
            <div className="hero">
                <div className="hero-overlay"></div>
                <div className="hero-image"></div>
                
                {/* Animated Background Elements */}
                <div className="floating-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                    <div className="shape shape-4"></div>
                </div>

                <div className="container hero-content">
                    {/* Badge with Animation */}
                    <div className="hero-badge animate-badge">
                        <div className="badge-icon">
                            <FaPhone />
                        </div>
                        <span>{t.header.hero.badge}</span>
                    </div>

                    {/* Main Title with Stagger Animation */}
                    <h1 className="header-hero-title">
                        <span className="title-line animate-slide-up">{t.header.hero.title.line1}</span>
                        <span className="title-line animate-slide-up-delay">
                            <span className="highlight">{t.header.hero.title.line2}</span> {t.header.hero.title.line3}
                        </span>
                    </h1>

                    {/* Subtitle with Type Effect */}
                    <p className="hero-subtitle animate-fade-in">
                        {t.header.hero.subtitle}
                    </p>

                    {/* Hero Search Bar */}
                    <HeroSearchBar />
                    
                    {/* Feature Cards with Professional Icons */}
                    <div className="hero-features">
                        {/* Card 1: Caută - Goes to Toate Utilajele */}
                        <div className="feature-card animate-card-1" onClick={() => navigate('/machines')}>
                            <div className="feature-icon-wrapper">
                                <div className="icon-circle">
                                    <FaFilter className="feature-icon-svg" />
                                </div>
                                <div className="icon-ring icon-ring-1"></div>
                                <div className="icon-ring icon-ring-2"></div>
                            </div>
                            <h3 className="feature-title">{t.header.hero.features.search.title}</h3>
                            <p className="feature-text">{t.header.hero.features.search.description}</p>
                            <div className="feature-number">01</div>
                        </div>

                        {/* Card 2: Categorii / Filters (was Cumpără) */}
                        <div className="feature-card animate-card-2" onClick={() => navigate('/categories')}>
                            <div className="feature-icon-wrapper">
                                <div className="icon-circle">
                                    <FaFilter className="feature-icon-svg" />
                                </div>
                                <div className="icon-ring icon-ring-1"></div>
                                <div className="icon-ring icon-ring-2"></div>
                            </div>
                            <h3 className="feature-title">{t.header.hero.features.categories.title}</h3>
                            <p className="feature-text">{t.header.hero.features.categories.description}</p>
                            <div className="feature-number">02</div>
                        </div>

                        {/* Card 3: Contactează - Goes to Contact Page */}
                        <div className="feature-card animate-card-3" onClick={() => navigate('/contact')}>
                            <div className="feature-icon-wrapper">
                                <div className="icon-circle">
                                    <FaPhone className="feature-icon-svg" />
                                </div>
                                <div className="icon-ring icon-ring-1"></div>
                                <div className="icon-ring icon-ring-2"></div>
                            </div>
                            <h3 className="feature-title">{t.header.hero.features.contact.title}</h3>
                            <p className="feature-text">{t.header.hero.features.contact.description}</p>
                            <div className="feature-number">03</div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
